import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";
import { Identifiable, CalendarHolidays } from "@planzone/dto";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  editCalendarHolidays(
    request: Boundaries["editCalendarHolidays"]["request"],
  ): void;
}

function useEditCalendarHolidays(
  calendarHolidays: Identifiable<CalendarHolidays>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isEditCalendarHolidayRequestPending(calendarHolidays),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isEditCalendarHolidaysSuccess(calendarHolidays),
    ),
    isRequestFailure: useSelector(() =>
      selector.isEditCalendarHolidaysFailure(calendarHolidays),
    ),
    editCalendarHolidays: core.editCalendarHolidays,
  };
}

export { useEditCalendarHolidays };
